import React, { useMemo, useRef, useState } from "react";
import OtpInput from "components/otpInput";
import { QRCodeSVG } from "qrcode.react";
import { authenticator as otplib } from "otplib";
import classnames from "classnames";
import { translate } from "reducers/i18n";
import styles from "./otp.module.css";

const NewOtpAuthenticator = ({ handleSubmit, isSubmitting }) => {
  const inputRef = useRef();
  const secret = useMemo(() => otplib.generateSecret(16), []);
  const [name, setName] = useState("");
  const [isEditing, setIsEditing] = useState(true);
  const [showOtpRegistration, setShowOtpRegistration] = useState(false);

  const handleKeyDown = ({ key }) => {
    if (key === "Enter") {
      setIsEditing(false);
    }
  };

  const handleShowOtpRegistration = () => {
    setShowOtpRegistration(prev => {
      if (prev) {
        setName("");
        setIsEditing(true);
      }

      return !prev;
    });
  };

  const handleToggle = () => {
    setIsEditing(prev => !prev);
  };

  const handleSubmitToken = async token => {
    await handleSubmit({ name, secret, token });
    setName("");
    setIsEditing(true);
    setShowOtpRegistration(false);
  };

  return (
    <li className="list-group-item">
      <span className="badge badge-secondary badge-pill text-uppercase mr-3">otp</span>
      <button className="" type="button" onClick={handleShowOtpRegistration}>
        {translate("authenticator_add")}
      </button>
      <div className={classnames("collapse mt-3", { show: showOtpRegistration })}>
        <p>{translate("authenticator_name")}</p>
        <div className="row messageProp align-items-center mb-3">
          <div className="col">
            <div className="input-group">
              <input
                className={classnames("form-control", styles.identifier, { [styles.disabled]: !isEditing })}
                disabled={!isEditing}
                type="text"
                name="name"
                id="name"
                ref={el => (inputRef.current = el)}
                value={name}
                onKeyDown={handleKeyDown}
                onChange={({ target: { value } }) => setName(value)}
                required
              />
              <div className="input-group-append">
                <button className="btn btn-primary button" type="button" onClick={handleToggle}>
                  {isEditing ? translate("authenticator_generate_qr") : translate("authenticator_edit_name")}
                </button>
              </div>
            </div>
          </div>
        </div>
        {isEditing ? null : (
          <>
            <p>{translate("authenticator_prompt")}</p>
            <div className="d-flex justify-content-center py-3 mb-3">
              <QRCodeSVG level="H" size={256} value={otplib.keyuri(name, "Bastion 365", secret)} />
            </div>
            <OtpInput handleSubmit={handleSubmitToken} isSubmitting={isSubmitting} />
          </>
        )}
      </div>
    </li>
  );
};

export default NewOtpAuthenticator;
